// 261010 UI1a — tải N file clip bằng <a download>. Không zip, không gọi BE. Trình duyệt có thể bỏ `download` với URL khác nguồn gốc (CDN) và chặn nhiều lần tải liên tiếp ⇒ mặc định mở tab mới (`target=_blank`).
import type { CapCutRow } from './workflowCapCutUtils';

export function downloadOne(r: Pick<CapCutRow, 'url' | 'fileName'>): void {
  if (!r.url) return;
  const a = document.createElement('a');
  a.href = r.url; a.download = r.fileName || 'video.mp4'; a.target = '_blank'; a.rel = 'noopener noreferrer';
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
}
/** Mỗi file cách nhau ~400 ms để trình duyệt không gộp / chặn. */
export function downloadAll(rows: CapCutRow[]): void {
  rows.filter((r) => r.state === 'OK').forEach((r, i) => { window.setTimeout(() => downloadOne(r), i * 400); });
}
